// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_f-1";
export var movingGradient = "_f-4";
export var movingGradientBlock = "_f-2";
export var skeleton = "_f-0";
export var skeletonText = "_f-3";